<template>
  <step-base :cta-props="ctaProps" @click="nextClicked" :with-login-link="withLoginLink" :page-background-color="pageBackgroundColor">
      <div class="ri-body margin-bottom-xxs">{{ signupText }}</div>
      <div class="ri-large-headline ri-alte margin-bottom-xxs">איך קוראים לך?</div>
      <div class="margin-top-ml">
        <text-input
          label-text="שם פרטי"
          :value="firstName"
          :onInput="checkAndSetFirstName"
          :error="false"/>
        <text-input
          label-text="שם משפחה"
          :value="lastName"
          :onInput="checkAndSetLastName"
          :error="false"/>
      </div>
  </step-base>
</template>

<script>

import Segment from '@/Segment';
import BrowserInfo from '@/mixins/BrowserInfo';
import BaseUI from '@riseupil/base-ui';
import { hardRefresh } from '@/router';
import _ from 'lodash';
import { mapMutations, mapState } from 'vuex';
import StepBase from './StepBase';

export default {
  name: 'EnterName',
  mixins: [BrowserInfo],
  components: {
    TextInput: BaseUI.V2Components.TextInput,
    StepBase,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
    signupText: {
      type: String,
      required: true,
    },
    extraCtaProps: {
      type: Object,
      required: false,
    },
    withLoginLink: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    Segment.trackUserGot(`${this.segmentEventPrefix}EnterName_Entered_Marketing`);
    Segment.trackUserGot(`${this.segmentEventPrefix}RegistrationEntered_Split`, {
      userAgentFromNavigator: this.userAgent,
      isFacebookApp: this.isFacebookApp,
    });
    Segment.trackUserGotToPixel(`${this.segmentEventPrefix}RE_Split`);
    Segment.trackUserGotToPixel(`${this.segmentEventPrefix}RegistrationEntered_Split_NameEntered`);
  },
  computed: {
    ...mapState('signup', ['firstName', 'lastName', 'segmentEventPrefix']),
    disabled() {
      return _.trim(this.firstName).length < 2 || _.trim(this.lastName).length < 2;
    },
    pageBackgroundColor() {
      return this.extraCtaProps ? this.extraCtaProps.pageBackgroundColor : undefined;
    },
    ctaProps() {
      return {
        buttonProps: {
          title: 'קדימה',
          disabled: this.disabled,
        },
        ...this.extraCtaProps,
      };
    },
  },
  methods: {
    ...mapMutations('signup', ['setFirstName', 'setLastName']),

    checkAndSetFirstName(value) {
      this.setFirstName(value);
    },
    checkAndSetLastName(value) {
      this.setLastName(value);
    },
    goToLogin() {
      Segment.trackUserInteraction('GoToLogin_Split');
      hardRefresh('/sr');
    },
    nextClicked() {
      Segment.trackUserInteraction(`${this.segmentEventPrefix}EnterName_NextClicked_Marketing`);
      Segment.trackUserGotToPixel(`${this.segmentEventPrefix}RegistrationEntered_Split_NameEntered_NextClicked`);
      Segment.trackUserInteraction('buttonClicked', {
        componentName: 'EnterName',
        buttonText: this.ctaProps.buttonProps.title,
      });
      this.nextStep();
    },
  },
};

</script>
<style lang="scss" scoped>
</style>
